import React, { useState } from 'react';
import CCModal2025 from '../../../../../components/ccModal2025';
import { I18n } from 'react-redux-i18n';
import CcCheckbox from '../../../../../components/ccCheckbox/CcCheckbox';
import { Button, Form, FormControl, FormGroup } from 'react-bootstrap';
import FormControlCustom from '../../../../../components/formControlCustom';
import { IoIosInformationCircleOutline } from 'react-icons/io';
import {
  CCLiteCommonFunc,
  formatCurrencyHasSymbol,
  getCurrencySymbolFromISO,
} from '../../../../../utils/commonFunctions';

const AutoRechargePopup = ({
  onClose,
  billingUsage,
  onBoardingBillingAutoRechargeSetting,
}) => {
  const [formState, setFormState] = useState(
    billingUsage.topUpPolicy || {
      amount: 0,
      threshHold: 0,
      autoCharge: true,
    }
  );

  const [isSubmmitted, setSubmitted] = useState(false);

  const [validState, setValidState] = useState({});
  const ValidatorCallback = (id, valid) => {
    setValidState((prevState) => {
      const newValidState = { ...prevState };
      if (newValidState && newValidState[id] !== valid) {
        newValidState[id] = valid;
        return newValidState;
      }
      return prevState;
    });
  };

  const onSubmit = async (data) => {
    setSubmitted(true);
    if (!CCLiteCommonFunc.isFormValid(validState)) {
      return;
    }
    onBoardingBillingAutoRechargeSetting(formState);
  };

  return (
    <CCModal2025
      isShow={true}
      onClose={onClose}
      title={I18n.t('billingUsage.autoChargeTitle')}
      btnCloseText={I18n.t('driver.Cancel')}
      btnSubmitText={I18n.t('driver.Save')}
      onSubmit={onSubmit}
    >
      <div>
        <p>{I18n.t('billingUsage.autoChargeTitleQuestion')}</p>
        <CcCheckbox
          text={I18n.t('billingUsage.autoChargeCbx')}
          checked={formState.autoCharge}
          onChange={(e) => {
            setFormState((prevState) => ({
              ...prevState,
              autoCharge: e.target.checked,
            }));
          }}
        />
        <FormGroup>
          <FormControlCustom
            validatorCallback={ValidatorCallback}
            valid={validState}
            value={formState.threshHold}
            isSubmitted={isSubmmitted}
            handleChange={(value) => {
              setFormState((prevState) => ({
                ...prevState,
                threshHold: value,
              }));
            }}
            field={{
              title: I18n.t('billingUsage.crdBelow'),
              key: 'amount',
              type: 'number',
              placeholder: '0',
              textGRPrepend: getCurrencySymbolFromISO(
                billingUsage?.currencyISO
              ),
              rules: {
                required: '',
                min: { value: 5, message: I18n.t('billingUsage.amountMustBeGreaterThan').format(5) },
                max: { value: 95, message: I18n.t('billingUsage.amountMustBeLessThan').format(95) },
              },
              text: I18n.t('billingUsage.crdBelowNote').format(
                formatCurrencyHasSymbol(5, billingUsage?.currencyISO),
                formatCurrencyHasSymbol(95, billingUsage?.currencyISO)
              ),
            }}
          />
        </FormGroup>
        <FormGroup>
          <FormControlCustom
            validatorCallback={ValidatorCallback}
            valid={validState}
            value={formState.amount}
            isSubmitted={isSubmmitted}
            handleChange={(value) => {
              setFormState((prevState) => ({
                ...prevState,
                amount: value,
              }));
            }}
            field={{
              title: I18n.t('billingUsage.backupTo'),
              key: 'threshHold',
              type: 'number',
              placeholder: '0',
              textGRPrepend: getCurrencySymbolFromISO(
                billingUsage?.currencyISO
              ),
              rules: {
                required: 'Amount is required',
                min: { value: parseInt(formState.threshHold || 10) + 5, message: I18n.t('billingUsage.amountMustBeGreaterThan').format(parseInt(formState.threshHold || 10) + 5) },
                max: { value: 100, message: I18n.t('billingUsage.amountMustBeLessThan').format(100) },
              },
              text: I18n.t('billingUsage.backupToNote').format(
                formatCurrencyHasSymbol(parseInt(formState.threshHold || 10) + 5, billingUsage?.currencyISO),
                formatCurrencyHasSymbol(100, billingUsage?.currencyISO)
              ),
            }}
          />
        </FormGroup>
        <div
          className="d-flex align-items-start"
          style={{
            border: '1px solid #3F4350',
            padding: '10px',
            borderRadius: '5px',
            marginTop: '10px',
          }}
        >
          <IoIosInformationCircleOutline fontSize={24} />
          <p
            style={{ fontSize: '14px', fontWeight: '500', marginLeft: '10px' }}
          >
            {I18n.t('billingUsage.rechargeWillHappenImmediately')} <br />
            {I18n.t('billingUsage.rechargeWillHappenImmediatelyDescription')}
          </p>
        </div>
      </div>
    </CCModal2025>
  );
};

export default AutoRechargePopup;
